import React, { useContext, useEffect, useState } from "react";
import FlatCard from "components/UI-lib/FlatCard";
import { OrgContext } from "contexts/OrgContext";
import { BillingContext } from "contexts/BillingContext";
import agent from "server";
import { BREV_SUPPORT_EMAIL } from "constants/index";

function OrgResourceLimits({ includeTitle = true }: { includeTitle?: boolean }) {
  const [currentResourceUsage, setCurrentResourceUsage] = useState("");
  const orgContext = useContext(OrgContext);
  const billingContext = useContext(BillingContext);

  const resourceLimitDollars =
    (billingContext.billingProfile?.resource_limits?.max_resources || 0) / 100;

  useEffect(() => {
    if (!orgContext.activeOrgId) return;

    const fetchResourceLimits = async () => {
      const resourcesRes = await agent.ResourceLimits.getResourceLimits(
        orgContext.activeOrgId,
        ""
      );
      if (resourcesRes.success) {
        const data = resourcesRes.data as any;
        setCurrentResourceUsage(data.totalCostOfWorkspaces);
      }
    };

    fetchResourceLimits();
  }, [orgContext.activeOrgId]);

  return (
    <FlatCard>
      {includeTitle && (
        <h3 className="text-xl mb-3 font-medium dark:text-white">
          Resource Limit
        </h3>
      )}
      <p className="mb-2 text-sm text-gray-700 dark:text-secondary">
        Your organization has a resource usage limit of{" "}
        {resourceLimitDollars.toLocaleString("en-US", {
          style: "currency",
          currency: "USD",
        })}{" "}
        per hour
      </p>
      <div
        onClick={(e) => {
          e.stopPropagation();
        }}
        className="bg-white dark:bg-zinc-900 dark:border-zinc-800 w-full h-5 rounded border-solid border flex items-center justify-start"
      >
        <div
          onClick={(e) => {
            e.stopPropagation();
          }}
          style={{
            width: `${(parseFloat(currentResourceUsage) / resourceLimitDollars) * 100}%`,
          }}
          className={`text-base h-5 bg-highlight rounded dark:border-zinc-800 border-solid border-r `}
        ></div>
      </div>
      <div className="flex text-sm ml-1 mt-1">
        <p className="mb-2 text-sm text-gray-500 dark:text-secondary">
          Current usage: {currentResourceUsage ? `$${parseFloat(currentResourceUsage).toFixed(3)}` : "—"} per hour
        </p>
        <p className="mb-2 text-sm text-gray-500 dark:text-secondary ml-auto">
          Available usage: {currentResourceUsage ? `$${(resourceLimitDollars - parseFloat(currentResourceUsage)).toFixed(3)}` : "—"} per hour
        </p>
      </div>
      <div className="mb-1 mt-1 max-w-2xl text-sm text-gray-700 dark:text-secondary">
        Need more resources? Reach out to us at{" "}
        <a
          href={`mailto:${BREV_SUPPORT_EMAIL}`}
          className="underline cursor-pointer"
        >
          {BREV_SUPPORT_EMAIL}
        </a>
      </div>
    </FlatCard>
  );
}

export default OrgResourceLimits;
